import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EmailService {

    // Cria a tag img com a assinatura do usuário
    createAssinaturaEmail(url: string): string {
        if (url && url.trim().length > 0) {
            return `<br><br><br><br><img src='${url}' style='max-height:200px; max-width: 100%; border=0'/>`;
        }

        return '';
    }
}
